<template>
  <div class="container-fluid" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img :src="`${pageUrl.imgUrl}${pageInfo.pic}`" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img :src="`${pageUrl.imgUrl}${pageInfo.pic}`" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div> 
    </div>

    <div class="row" :class="{'hidden-xs hidden-sm':isShowWeb}">
      <div class="dynamic-center">
        <div class="center-center-font" v-html="lanType==1?pageInfo.content:pageInfo.contentEn"></div>
      </div>
    </div>

    <div class="row hidden-md hidden-lg" v-if="isShowWeb">
      <div class="phone-dynamic-center">
        <div class="phone-center-font" v-html="lanType==1?pageInfo.content:pageInfo.contentEn"></div>
      </div>
    </div>


    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr } from '@/utils/util';
import config from '@/utils/config';
export default {
  name: 'activity',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      lanType:1,
      pageInfo:{},
      page:1,
      per_page:9,
      pageList:[],
      total:0,
      pageUrl: config.urlList,
      isShowWeb:config.urlList.isShowWeb
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    queryCampaign(){
      const vm=this
      axios.post(
        `${vm.pageUrl.queryUrl}/api/wwf/videos`,
        {
          page: vm.pageNum,
          per_page: 9,
        },
        
      ).then(res => {
        if(res.data.code==1){
          res.data.data.data.titleEn=res.data.data.data.titleEn?res.data.data.data.titleEn:res.data.data.data.title
          vm.pageList=res.data.data.data
          console.log(res.data.data)
          // vm.current_page=res.data.data.last_page
          // vm.total=res.data.data.total
        }
      })
    },
    choicePage(num){
      const vm=this
      vm.page=num;
      vm.queryCampaign();
    },
    queryPageInfo(){
      const vm=this;
      let str = "<p>CBH recognizes that businesses and industry have key roles in reducing global greenhouse gas emissions and implementing climate-smart technologies and innovations. They must be part of the global effort to tackle climate change, and take their responsibilities to meet the goals of the Paris Agreement.</p><p>It is also a compelling business case to take immediate action on climate change. Companies demonstrating leadership on climate change have shown improved reputation with customers, suppliers, investors, and policy makers. They are staying ahead of future climate regulations with less exposure of climate risks. Reduced energy use and emissions also indicates reduced costs and better efficiency, which leaves better chance for internal innovation.</p><p>Taking climate action simply makes good business sense.</p><p>Leading companies around the world step forward every day to commit to bold climate and renewable energy targets, not only for their direct operations but also for their supply chains. Across sectors — from retail, to textiles and apparel, technology and many others — global supply chains often lead back to China.</p><p>Join Climate Business Hub China. Your climate journey starts here.</p><p>If you would join CBH, or are interested in setting SBTi, or signing Renewable Energy Buyers' Principles please email:</p><p>Yuanna LUO OPF South China contact person, EnergyTransitionto100%Renewable<br/>ynluo@wwf-opf.org</p><p>Qian LIU OPF Assistance Program Officer, Energy Transition to 100% Renewable(Beijing)<br/>qliu@wwf-opf.org</p><p>If you are interested in Climate Solver please email:<br/>Shasha Cheng   Program Manager  Energy Transition & Climate Solver, WWF China<br/>shshchen@wwfchina.org</p>"

      axios.get(
      `${config.urlList.queryUrl}/api/cbh/page/1`,
      ).then(res => {
        if(res.data.code==1){
          res.data.data.titleEn = res.data.data.titleEn ? res.data.data.titleEn : 'JoinUs'
          res.data.data.contentEn = res.data.data.contentEn ? res.data.data.contentEn : str
          res.data.data.updateTime = res.data.data.updated_at.split('T')[0];

          res.data.data.content = res.data.data.content ? res.data.data.content.replace(/(width|height)="\d*"\s*/g, '') : ''
          res.data.data.contentEn = res.data.data.contentEn ? res.data.data.contentEn.replace(/(width|height)="\d*"\s*/g, '') : ''
          
          vm.pageInfo = res.data.data;
          console.log("vm.pageInfo++++++++++++++")
          console.log(vm.pageInfo)
        }
      })
    },
    upPage(){
      const vm=this;
      if(vm.page>1){
        vm.page--
        vm.queryCampaign();
      }
    },
    downPage(){
      const vm=this;
      if(vm.page<vm.current_page){
        vm.page++
      }
      vm.queryCampaign();
    },
    moreBtn(){
      const vm=this
      if(vm.total>vm.per_page){
        vm.per_page+=9;
        vm.queryCampaign()
      }
    },
    queryStat(){
      const vm=this
      axios.post(
        `${vm.pageUrl.queryUrl}/api/wwf/stat`,
        {
          source:1,
          url:window.location.href
        },
      ).then(res => {
        
      })
    },
  },
  created () {
    const vm = this;
  },
  mounted(){
    const vm=this
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    vm.queryPageInfo();
  }
}
</script>
<style scoped>
/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 4.0625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.45rem;
  color: #fff;
  font-family:'wwf';
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
  font-family:'wwf';
}

/**  最新动态  **/
.dynamic-center{
  padding: 0.5rem 2rem;
}
.web-index-neck{
  font-size: 0.375rem;
  color: #000000;
  margin-top: 0.425rem;
  line-height: 1.6;
  position: relative;
}
.web-index-neck::before{
  content: "";
  display: block;
  width: 0.75rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.web-neck-center{
  margin: 0.3125rem 0.5rem 0;
  height: auto;
}
.img-info-list{
  width: 32%;
  height: auto;
  -webkit-box-shadow: #d1d1d1 0px 0px 10px; 
  -moz-box-shadow: #d1d1d1 0px 0px 10px; 
  box-shadow: #d1d1d1 0px 0px 10px;
  margin: 0 4px 0.3rem;
}
.info-list-top{
  width: 100%;
  height: 100%;
  position: relative;
}
.list-top-img{
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
}
.info-list-middle{
  padding: 0.1rem 0.05rem;
  background: #fff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 2px 4px #d1d1d1;
}
.list-middle-tips{
  font-size: 0.1125rem;
  color: #cf6e32;
  font-style: italic;
  text-align: left;
}
.list-middle-title{
  font-size: 0.13rem;
  color: #000;
  /* font-weight: 600; */
  margin-bottom: 0.125rem;
  text-align: left;
  height: 0.35rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-family:'wwf';
}
.list-middle-center{
  font-size: 0.1rem;
  color: #666666;
  line-height: 1.7;
  text-align: left;
}
.info-list-layer{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.list-layer-li{
  margin-bottom: 0.1875rem;
  padding: 6px 10px;
  font-size: 0.0875rem;
  color: #fff;
  background: #cf6e32;
  margin-right: 0.0625rem;
  display: inline-block;
}
.list-layer-li:nth-child(1){
  margin-left: 0.25rem;
}
.neck-indicators{
  position: absolute;
  bottom: 0 !important;
}
.neck-indicators li{
  background: #aaaaaa !important;
}
.glyphicon-chevron-left,.glyphicon-chevron-right{
  margin: 0 !important;
  color: #000;
  text-shadow: none;
  font-size: 18px;
}
.neck-btn-left{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  left: -0.21875rem;
  transform: translateY(-50%);
}
.neck-btn-right{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  right: -0.21875rem;
  transform: translateY(-50%);
}
.dynamic-paging{
  margin-top: 0.325rem;
  padding: 0 0.5rem;
}
.dynamic-paging-btn{
  width: 1.25rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #cf6e32;
  font-weight: 600;
  margin: 0 0.125rem;
}
.dynamic-paging-list{
  width: 0.375rem;
  height: 0.375rem;
  background: #eeeeee;
  font-size: 0.15rem;
  color: #cf6e32;
  font-weight: 600;
  margin: 0 0.125rem;
  margin-bottom: 0;
}
.bg1{
  background: #cf6e32;
  color: #fff;
}
.wraps {
  content: "";
  display: block;
  width: 32%;
  height: 1px;
}

/**  web最新动态  **/
.phone-index-neck{
  font-size: 0.72rem;
  font-weight: 500;
  color: #000000;
  margin-top: 0.906rem;
  line-height: 2;
  position: relative;
}
.phone-index-neck::before{
  content: "";
  display: block;
  width: 1.44rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.phone-info-list{
  width: 100%;
  margin-bottom: 1.1rem;
  margin-left: 0;
}
.phone-list-top{
  height: 5.14rem;
  width: 100%;
}
.phone-list-middle{
  padding: 0.2rem 0.4rem;
}
.phone-list-tips{
  font-size: 0.42rem;
  font-weight: 500;
}
.phone-list-title{
  font-size: 0.48rem;
  margin-top: 0.29rem;
  margin-bottom: 0.4rem;
  height: auto;
}
.phone-list-center{
  font-size: 0.42rem;
  margin-top: 0.2rem;
}
.phone-dynamic-center{
  padding: 0.5rem;
}
.phone-legs-btn{
  width: 4rem;
  height: 1.067rem;
  background: #cf6e32;
  font-size: 0.4rem;
  color: #fff;
  margin: 0 auto 0.5rem;
}
.center-center-font{
  font-size: 0.1125rem;
  line-height: 1.6;
  margin-bottom: 0.2rem;
  text-align: left;
}
.phone-center-font{
  font-size: 0.32rem;
  line-height: 1.6;
  margin-bottom: 0.4rem;
  text-align: left;
}
</style>

